/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useUploadCisUsers } from '@api/hooks';
import { MediaLibraryModal } from '@molecules';
import * as mediaUtils from '@utils/media';
import { Typography, notification } from '@atoms';

import FileSelect from '../FileSelect';

const FILE_EXTENSIONS = '.csv';

const UploadModal = ({ visible, hide }) => {
  const [file, setFile] = React.useState(null);
  const { fileName } = mediaUtils.getInfo({ file });

  const [uploadCisUsers, uploadCisUsersQuery] = useUploadCisUsers({ throwOnError: true });

  const handleClose = React.useCallback(() => {
    setFile(null);
    hide();
  }, [hide]);

  const handleOnOk = React.useCallback(async () => {
    try {
      await uploadCisUsers({ file });
      notification.success({ message: 'Added successfully!' });
      handleClose();
    } catch (e) {
      notification.error({ message: 'An error occurred while adding' });
      console.log(e);
    }
  }, [uploadCisUsers, file, handleClose]);

  const okDisabled = !file;
  const isLoading = uploadCisUsersQuery.status === 'loading';

  return (
    <MediaLibraryModal
      visible={visible}
      onCancel={handleClose}
      okText="ADD FILE"
      loading={isLoading}
      onOk={handleOnOk}
      okDisabled={okDisabled}
      error={uploadCisUsersQuery.error}
    >
      <FileSelect file={file} onChange={setFile} accept={FILE_EXTENSIONS}>
        {fileName && (
          <>
            <Typography.Paragraph>{fileName}</Typography.Paragraph>
          </>
        )}
      </FileSelect>
    </MediaLibraryModal>
  );
};

export default UploadModal;
